import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.scss';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={styles.notFound}>
      <div className={styles.notFound__content}>
        <div className={styles.notFound__errorCode}>404</div>
        <h1 className={styles.notFound__title}>Страница не найдена</h1>
        <p className={styles.notFound__description}>
          К сожалению, запрашиваемая страница не существует или была перемещена.
        </p>
        <div className={styles.notFound__actions}>
          <button
            className={`${styles.notFound__button} ${styles['notFound__button--primary']}`}
            onClick={() => navigate('/chat')}
          >
            Вернуться в чат
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
